import { Injectable } from '@angular/core';
import { ReadyHttpClient } from './ready-http-client';
import {
  IAssistantConversationResponse
} from './contracts/chat-assistant.contracts';

export interface SendMessageRequest {
  externalId: string;
  message: string;
}

export interface ChatkitSessionResponse {
  client_secret: string;
}

export interface ChatkitRefreshRequest {
  currentClientSecret: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChatAssistantApi {
  constructor(private http: ReadyHttpClient) {}

  // Legacy assistant endpoints
  startConversation(beaconId: string): Promise<IAssistantConversationResponse> {
    return this.http.post(`/tables/${beaconId}/assistant/conversations`);
  }

  getConversationById(
    beaconId: string,
    conversationId: string
  ): Promise<IAssistantConversationResponse> {
    return this.http.get(
      `/tables/${beaconId}/assistant/conversations/${conversationId}`
    );
  }

  sendMessage(
    beaconId: string,
    bodyReq: SendMessageRequest
  ): Promise<IAssistantConversationResponse> {
    return this.http.post(
      `/tables/${beaconId}/assistant/conversations/${bodyReq.externalId}/message`,
      {
        ...bodyReq
      }
    );
  }

  // ChatKit session endpoints
  createChatkitSession(beaconId: string, menuContext: string, locationId: string, tableName: string): Promise<ChatkitSessionResponse> {
    return this.http.post(`/chatkit/session`, {
      menuContext,
      locationId,
      beaconId,
      tableName
    });
  }

  refreshChatkitSession(beaconId: string, currentClientSecret: string, locationId: string, tableName: string): Promise<ChatkitSessionResponse> {
    return this.http.post(`/chatkit/refresh`, {
      currentClientSecret,
      locationId,
      beaconId,
      tableName
    });
  }

  /**
   * Request a drink refill for the current table (used by ChatKit tool).
   * Calls ChatKit API; backend publishes to requestDrinkRefill signal for dashboard/FOH.
   */
  requestDrinkRefill(beaconId: string, drinkType?: string): Promise<{ success: boolean }> {
    return this.http.post(`/chatkit/request-drink-refill`, {
      beaconId,
      drinkType: drinkType ?? ''
    });
  }
}
